/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ConnectingModal from "../Modals/ConnectingModal/ConnectingModal";
import useNetwork from "../../Hooks/useNetwork";
import { useAccount, useDisconnect, useSignMessage } from "wagmi";
import { useCreateUser } from "../../Hooks/api/useCreateUser";
import useCheckUser from "../../Hooks/api/useCheckUser";
import { setConnectingModal,  setSignMessageData,  setSignSignatureDate, setUserEmail, updateNewUser, updateUser } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setSignMessageModal } from "../../redux/slices/userSlice";
import { toast } from "react-toastify";
import { UserRejectedRequestError } from "viem";



const LayoutModal = () => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const { validChain } = useNetwork();
  const { address, isConnected: isWalletConnected } = useAccount();
const {disconnect} =useDisconnect()
const location =useLocation()
  const {
    data: signMessageData,
    signMessageAsync,
    variables,
  } = useSignMessage();
  
  const { mutate } = useCreateUser({onSuccess: userSignUp});
  const { mutate: CheckUserMutation } = useCheckUser();
  const {newUser,isConnectingModal, isSignMessageModal, signSignatureData} = useSelector((state) => state.user); 
 const dispatch =useDispatch()
 const navigate =useNavigate()

  function userSignUp(){
    dispatch(updateUser({ user: userName, email: email }));
    dispatch(setUserEmail(email));
    dispatch(setConnectingModal(false));
    navigate('/')
  }


  const handleSignUp = async (email, user) => {
    try {
      mutate({
        wallet_address: address,
        user_email: email,
        user_name: user,
      });
    } catch (error) {
      toast.error("Something went wrong.")
    }
  };


  React.useEffect(() => {
    if (isWalletConnected && validChain && newUser) {
      dispatch(setConnectingModal(true));
    }   
  }, [isWalletConnected, validChain, newUser]);

  const closeModal = () => {
    dispatch(setConnectingModal(false));
  };
  

  const handleSignMessage = async (message) => {
    try {
      if (!isSignMessageModal) {
        await signMessageAsync({ message });
        dispatch(setSignMessageModal(true));
      }
    } catch (error) {
      if(error instanceof UserRejectedRequestError){

        disconnect();
        toast.error("Please sign to connect");
      }
      
    }
  };
  
  
  
  useEffect(() => {
    if (address) {
      CheckUserMutation(address, {
        onSuccess: (response) => {
          const new_user = response.new_user; 
          updateNewUser(new_user);
         
        },
      });
    }
      if(isWalletConnected && address?.length>0 && !signSignatureData && !isSignMessageModal){
        const message = `Click to sign in to Golden Years.`
        // We assure you that this message will not trigger any transaction or cost the user any gas fees. 
        // Your authentication status will reset after 24 hours. 
        // Wallet address: ${address}`;
        handleSignMessage(message);
     }

     if(address && signMessageData && isSignMessageModal){
      dispatch(setSignSignatureDate(signMessageData));
      dispatch(setSignMessageData(variables.message))
     }

  }, [address, signMessageData, isSignMessageModal]);

  return (
    <div className="w-full">
      {isConnectingModal && location.pathname !=='/terms-and-conditions' && location.pathname !=='/privacy-policy'  && (
        <ConnectingModal closeModal={closeModal} handleSignUp={handleSignUp} setUserName={setUserName} setEmail={setEmail} userName={userName} email={email} />
      )}
    </div>
  );
};

export default LayoutModal;
